export default "__VITE_ASSET__Ce0fRO25__"